import {actions} from '~utils/ngrx-util';
import { EntityGrupoUsuario } from './entity-grupo-usuario.model';


const entityName = 'EntityGrupoUsuario';
const { add, adds, upsert, upserts, update, updates, remove, removes, load, clear } = actions<EntityGrupoUsuario>(entityName);
export const addEntityGrupoUsuario = add;
export const addEntityGrupoUsuarios = adds;
export const upsertEntityGrupoUsuario = upsert;
export const upsertEntityGrupoUsuarios = upserts;
export const updateEntityGrupoUsuario = update;
export const updateEntityGrupoUsuarios = updates;
export const deleteEntityGrupoUsuario = remove;
export const deleteEntityGrupoUsuarios = removes;
export const loadEntityGrupoUsuario = load;
export const clearEntityGrupoUsuario = clear;
